import type { ConsumeDemoRequest, ConsumeDemoResponse } from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function consumeDemoLink(req: ConsumeDemoRequest): Promise<ConsumeDemoResponse> {
  return apiFetch<ConsumeDemoResponse>('/demo/consume', { method: 'POST', json: req });
}
